import React, { useState, useContext, useMemo } from 'react';
import { NavLink } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft, faSquareXmark } from '@fortawesome/free-solid-svg-icons';

import { MobileContext } from 'context';
import RoundTimer from './RoundTimer/index.js';
import useKeyPress from 'utils/Hooks/useKey.js';
import { EMBEDDED_SESSION } from 'const';
import { useRoundDuration, useCurrentRound } from 'utils/Hooks';
import menuItems from './menu.js';
import DogeBetsLogo from 'assets/DogeBetsLogo1.png';
import ConnectButtonRK from './Connection/connection_new.tsx';
import './Navbar.scss';
import './menu.scss';

function Navbar(props) {
  const isMobile = useContext(MobileContext);

  const currentRound = useCurrentRound();
  const roundDuration = useRoundDuration();
  const [showSidebar, SetSidebarShown] = useState(false);

  useKeyPress(['Escape'], () => SetSidebarShown(false));
  useKeyPress(['m'], () => SetSidebarShown(!showSidebar));

  const sidebar = useMemo(Sidebar
    , [showSidebar]);

  function ToggleSidebarVisibility() {
    SetSidebarShown(!showSidebar);
  };


  const mRoundTimer = useMemo(() => {
    return (<RoundTimer
      targetTimestamp={currentRound?.closeTimestamp}
      roundDuration={roundDuration}
      ongoingMessage={isMobile ? 'Left: ' : 'Round Ends in: '}
      endedMessage={isMobile ? 'Executing...' : 'Executing contract...' }
      showImage={true}
    />);
  }, [currentRound, roundDuration, isMobile]);


  const mainPageLink = (
    <NavLink to='/'>
      <img className={'DogeLogo' + (isMobile ? ' Mobile' : '')} src={DogeBetsLogo} alt='DoggoLogo' />
    </NavLink>
  );
  const mainPageLinkNewTab = (
    <NavLink target='_blank' rel='noopener noreferrer' to='/'>
      <img className={'DogeLogo' + (isMobile ? ' Mobile' : '')} src={DogeBetsLogo} alt='DoggoLogo' />
    </NavLink>
  );

  function Sidebar() {
    if (showSidebar)
      return (<React.Fragment>
        <div className='CloseEventOverlay' onClick={() => SetSidebarShown(false)} />
        <div className={'Sidebar' + (isMobile ? ' Mobile' : '')}>
          <ul className='MenuItems'>
            {Menu()}
          </ul>
        </div>
      </React.Fragment>);
    else
      return null;
  }


  function Menu() {
    let menuItemsJSX = [];
    menuItems.map((item, index) => {
      if (index === 0)
        menuItemsJSX.push(<li key={index} className='Item First' >
          {MenuItem(item, index)}
          <button className='Close'>
            <FontAwesomeIcon icon={faSquareXmark} size='2x'
              onClick={() => ToggleSidebarVisibility()}
            />
          </button>
        </li>);
      else
        menuItemsJSX.push(<li key={index} className='Item' >
          {MenuItem(item, index)}
        </li>);
    })
    return menuItemsJSX;
  }

  function MenuItem(item, index) {
    const cssClasses = GetFormattedCssClassesFor(item)

    return (<NavLink className={cssClasses}
      to={item.link} onClick={() => ToggleSidebarVisibility()}
    >
      <div className='Description'>
        {item.menuicon} {item.name}
      </div>
    </NavLink>);
  }

  function GetFormattedCssClassesFor(item) {
    if (item === undefined) throw new SyntaxError('Missing required argument: item');
    let cssClasses = 'ThemeBox ';
    if (item.cssClasses != undefined && item.cssClasses != null)
      cssClasses += item.cssClasses;
    if (item.primary)
      cssClasses += ' Primary';
    else
      cssClasses += ' Secondary';

    if (item.link.includes('prediction'))
      cssClasses += ' Prediction'
    return cssClasses
  }

  return (<React.Fragment>
    <div id='Navbar' className={'Navbar' + (isMobile ? ' Mobile' : '')}>
      <div className={'LeftSide' + (isMobile ? ' Mobile' : '')}>
        <div id='menu_button' className='ThemeButton MenuButton' onClick={() => ToggleSidebarVisibility(!showSidebar)}>
          <span onClick={() => ToggleSidebarVisibility(!showSidebar)}>
            <FontAwesomeIcon icon={faAlignLeft} className='white-centered-text' />
          </span>
        </div>
        <div className='GroupLogoTimer'>
          <div className={'DogeLogoContainer' + (isMobile ? ' Mobile' : '')}>
            {EMBEDDED_SESSION ? mainPageLinkNewTab : mainPageLink}

          </div>
          {isMobile ? mRoundTimer : null}
        </div>

      </div>
      <div className='GroupConnectTimer'>
        {isMobile ? null : mRoundTimer}
        {/*<Connection /> // oldschool non-RK connection */}
        <ConnectButtonRK />
      </div>
    </div>
    {sidebar}
  </React.Fragment>);
};

export default Navbar;
